// ReportSummary.tsx
import React from 'react';
import VulnerabilitiesChart from './VulnerabilitiesChart';
import CriticalityData from './CriticalityData';
import { ReportData } from '../../types/interfaces';
import { useTranslation } from 'react-i18next';

interface ReportSummaryProps {
  summaryData: ReportData | null; // Permite recibir null
}

const ReportSummary: React.FC<ReportSummaryProps> = ({ summaryData }) => {
  const { t } = useTranslation();
  // Si no hay informe seleccionado, mostramos mensaje grande y centrado
  if (!summaryData) {
    return (
      <div className="p-8 text-center">
        <p className="text-2xl text-gray-600 font-semibold">
          {t('reportSummary.noReportSelected')}
        </p>
      </div>
    );
  }

  // Si tenemos datos, mostramos la info
  return (
    <div>
      <div className="mb-6">
        <VulnerabilitiesChart summaryData={summaryData} />
      </div>
      <CriticalityData summaryData={summaryData} />
    </div>
  );
};

export default ReportSummary;